module.exports = __webpack_public_path__ + "static/media/20945780.ac2bd91a.jpg";